import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { editorialTeamMembershipOptions } from '@/module/Nomen/EditorialTeamMembership/model/EditorialTeamMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type EditorialTeamMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function EditorialTeamMembershipSelectControl<T extends FieldValues>(
  props: EditorialTeamMembershipSelectControlProps<T>,
) {
  const { data, isLoading, isError } = useQuery(editorialTeamMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
